import { Component, Input, Output, EventEmitter, OnDestroy, OnChanges } from '@angular/core';
import { DragulaService } from 'ng2-dragula';
import { Subscription } from 'rxjs';
import { posix } from 'path';

@Component({
  selector: 'app-drag-and-drop-list',
  templateUrl: './drag-and-drop-list.component.html',
  styleUrls: ['./drag-and-drop-list.component.css']
})
export class DragAndDropListComponent implements OnChanges, OnDestroy {
  @Input() channels: any[];
  @Input() channelPriorities: any[];
  @Input() savedPriorities: object[];

  @Output() priorityListChanged: EventEmitter<object[]> =   new EventEmitter();

  priorityList: any[] = [];
  channelsList: any[] = [];

  ngOnChanges() {
    this.channels.forEach(channel => this.channelsList.push(channel));

    if (this.savedPriorities.length == 0) {
      this.channelPriorities.forEach(priority => this.priorityList.push(priority));
    } else {
      this.savedPriorities.forEach(priority => this.priorityList.push(priority));
    }

    this.priorityList.forEach(priority =>
      this.channelsList.forEach(channel => {
        if (channel.name === priority.name) {
          let index = this.channelsList.indexOf(channel);
          this.channelsList.splice(index, 1);
        }
      })
    );

    this.priorityListChanged.emit(this.priorityList);
  }

  // RxJS Subscription is an excellent API for managing many unsubscribe calls.
  // See note below about unsubscribing.
  subs = new Subscription();

  constructor(private dragulaService: DragulaService) {

    this.subs.add(this.dragulaService.drop("CHANNELS")
      .subscribe(({ name, el, target, source, sibling }) => {
        this.priorityListChanged.emit(this.priorityList);
      })
    );

  }


  ngOnDestroy() {
    this.channelsList = this.channelsList.concat(this.priorityList);
    // destroy all the subscriptions at once
    this.subs.unsubscribe();
  }

}



// WEBPACK FOOTER //
// ./src/app/views/campaign/new-campaign/step-2/drag-and-drop-list/drag-and-drop-list.component.ts